module.exports = __webpack_public_path__ + "assets/img/useravatar_1.2c4c8b70.png";